import { render, staticRenderFns } from "./PrimaryFilterList.vue?vue&type=template&id=53c25508&"
import script from "./PrimaryFilterList.vue?vue&type=script&lang=js&"
export * from "./PrimaryFilterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports